module.exports = __webpack_public_path__ + "img/kj_images_03.70a74776.png";